import React, { useRef, useState, useEffect } from "react";
import { getRoutePointList } from "../../services/route-point.services";
import {
  CAvatar,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CToaster,
  CButton,
  CFormInput,
  CInputGroup,
  CInputGroupText,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilPeople, cilPencil, cilPlus, cilSearch } from "@coreui/icons";
import CustomPagination from "../../components/CustomPagination";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import { Link } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { getActiveCountryList } from "src/services/country.services";
import ReactSelect from "react-select";

const RoutePointManagementTable = () => {
  const toaster = useRef();
  const [userInfo, setUserInfo] = useState(
    localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null
  );
  const [toast, addToast] = useState("");
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);
  const [count, setCount] = useState(0);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [searchedString, setSearchedString] = useState("");
  const [countryOptions, setCountryOptions] = useState([]);
  const [selectedCountryOption, setSelectedCountryOption] = useState(null);

  useEffect(() => {
    if (userInfo?.userType === "superAdmin") getActiveCountry();
    getRoutePointItem(currentPage);
  }, []);

  const getActiveCountry = () => {
    const limit = 100;
    const page = 1;
    getActiveCountryList({ limit, page, status: true })
      .then(async (response) => {
        const countryData = response.data;
        let options = [];
        countryData.forEach((element) => {
          const option = {
            value: `${element._id}`,
            label: `${element.name} - ${element.code}`,
          };
          options.push(option);
        });
        setCountryOptions(options);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getRoutePointItem = (page, searchedString = null, country = null) => {
    setIsLoading(true);
    const params = {
      limit,
      page,
    };
    if (searchedString) {
      params.q = searchedString;
    }
    if (country) params.country = country;

    getRoutePointList(params)
      .then(async (response) => {
        setIsLoading(false);
        setCount(response.count);
        setData(response.data);
        setData(response.data);
        const totalPages = Math.ceil(response.count / limit);
        setTotalPages(totalPages);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const handlePageChange = (newPage) => {
    console.log("newPage", newPage);
    setCurrentPage(newPage);
    getRoutePointItem(newPage);
  };

  const handleOnInputChangeRountPointInfo = (value) => {
    setSearchedString(value);
  };

  const submitSearchButton = () => {
    if (searchedString) {
      getRoutePointItem(currentPage, searchedString);
    } else {
      getRoutePointItem(currentPage);
    }
  };

  const handleChangeCountry = (selectedOption) => {
    if (selectedOption) {
      setSelectedCountryOption(selectedOption);
      getRoutePointItem(currentPage, null, selectedOption.value);
    } else {
      setSelectedCountryOption("");
      getRoutePointItem(currentPage);
    }
  };

  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={5}>
              <h4 id="traffic" className="card-title mb-0">
                Route Point Management - Total: {count}
              </h4>
            </CCol>
            <CCol sm={7} className="d-none d-md-block">
              <div className="container-fluid px-0">
                <div className="row">
                  {userInfo?.userType === "superAdmin" && (
                    <CCol xs={4}>
                      <ReactSelect
                        value={selectedCountryOption}
                        onChange={handleChangeCountry}
                        options={countryOptions}
                        isClearable={true}
                        isDisabled={userInfo.userType !== "superAdmin"}
                        placeholder="Select Country"
                      />
                    </CCol>
                  )}

                  <CCol xs={userInfo?.userType === "superAdmin" ? 3 : 6}>
                    <CInputGroup className="mb-3">
                      <CFormInput
                        placeholder="Search Route Point Name, Location Code, City..."
                        onInput={(e) =>
                          handleOnInputChangeRountPointInfo(e.target.value)
                        }
                      />
                      <CInputGroupText>
                        <CIcon
                          icon={cilSearch}
                          onClick={submitSearchButton}
                          style={{ cursor: "pointer" }}
                        />
                      </CInputGroupText>
                    </CInputGroup>
                  </CCol>

                  <CCol xs={userInfo?.userType === "superAdmin" ? 5 : 6}>
                    <Link to="/create-route-point">
                      <CButton style={{ width: "100%" }}>
                        <CIcon icon={cilPlus} />
                        &nbsp; Create Route Point
                      </CButton>
                    </Link>
                  </CCol>
                </div>
              </div>
            </CCol>
          </CRow>
          <br />
          <CTable align="middle" className="mb-0 border" hover responsive>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell className="text-center">No.</CTableHeaderCell>
                <CTableHeaderCell>Name</CTableHeaderCell>
                <CTableHeaderCell>Location Code</CTableHeaderCell>
                <CTableHeaderCell>City</CTableHeaderCell>
                <CTableHeaderCell>Country</CTableHeaderCell>
                <CTableHeaderCell>Action</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {isLoading ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="6">Loading...</CTableDataCell>
                </CTableRow>
              ) : data.length == 0 ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="6">No data available</CTableDataCell>
                </CTableRow>
              ) : (
                data.map((item, index) => (
                  <CTableRow v-for="item in tableItems" key={index}>
                    <CTableDataCell className="text-center">
                      <div>{index + 1}</div>
                    </CTableDataCell>

                    <CTableDataCell className="text-capitalize">
                      {item.name}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item?.locationCode}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item?.city}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item?.country?.name}
                    </CTableDataCell>

                    <CTableDataCell>
                      <Link to={`/edit-route-point/${item._id}`}>
                        <CButton color="secondary" style={{ color: "white" }}>
                          <FaEdit />
                        </CButton>
                      </Link>
                    </CTableDataCell>
                  </CTableRow>
                ))
              )}
            </CTableBody>
          </CTable>
          <br />
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </CCardBody>
      </CCard>
      <DeleteModal
        visible={visibleDeleteModal}
        setVisibleDeleteModal={setVisibleDeleteModal}
        addToast={addToast}
      />
      <CToaster ref={toaster} push={toast} placement="top-end" />
    </>
  );
};

export default RoutePointManagementTable;
